import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useSnackbar } from 'notistack';

import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import { getProducts } from '../../../services/products.js';
import { updateCollectionsService } from '../../../services/collections';
import {
    addProductWithCollectionSort,
    buildCollectionUpdatePayload,
    getCollectionSortFields,
    persistCollectionSortPreference,
} from '../collectionProductSort';

const AutoCompleteProduct = ({
    storeId,
    collectionId,
    collectionData,
    listDataProduct,
    setListDataProduct,
}) => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const { enqueueSnackbar } = useSnackbar();
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [adding, setAdding] = useState(false);

    const addChip = async (value) => {
        if (!value) return;
        const productInCat = listDataProduct.find((pro) => pro.id === value.id || pro.name === value.name);
        if (productInCat !== undefined) return;

        const nextList = addProductWithCollectionSort(listDataProduct, value, collectionData);
        setListDataProduct(nextList);

        if (!collectionId || !collectionData?.id) return;

        setAdding(true);
        try {
            const payload = buildCollectionUpdatePayload(
                collectionData,
                nextList.map((p) => String(p.id))
            );
            await updateCollectionsService(storeId, payload);
            const { sort_by, sort_order } = getCollectionSortFields(collectionData);
            persistCollectionSortPreference(storeId, collectionId, sort_by, sort_order);
            enqueueSnackbar('Producto agregado a la categoría', {
                variant: 'success',
                autoHideDuration: 2500,
            });
        } catch (err) {
            setListDataProduct(listDataProduct);
            enqueueSnackbar('Error al agregar el producto a la categoría', {
                variant: 'error',
                autoHideDuration: 2500,
            });
        } finally {
            setAdding(false);
        }
    };

    useEffect(() => {
        if (inputValue?.length >= 3) {
            getProducts(storeId, inputValue)
                .then((res) => {
                    setProducts(res?.data || []);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [storeId, inputValue]);

    return (
        <Autocomplete
            id="asynchronous-product"
            style={{ width: '100%' }}
            open={open}
            disabled={adding}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onChange={(event, value) => addChip(value)}
            getOptionSelected={(option, value) => option.name === value.name}
            getOptionLabel={(option) => option.name}
            options={products}
            loading={loading}
            renderInput={(params) => (
                <FormControl>
                    {!isTabletOrMobile && (
                        <FormLabel>Ingresa al menos 3 caracteres para buscar un producto</FormLabel>
                    )}
                    <TextField
                        variant="outlined"
                        placeholder={isTabletOrMobile ? 'Buscar producto...' : ''}
                        {...params}
                        onChange={(e) => setInputValue(e?.target?.value)}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading || adding ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                            style={{ position: 'absolute', right: '11px' }}
                                        />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

const mapStateToProps = ({ auth }) => ({
    storeId: auth.storeId,
});

export default connect(mapStateToProps)(AutoCompleteProduct);
